import { render } from "./horizontal-scroll-manager.vue?vue&type=template&id=28206416"
import script from "./horizontal-scroll-manager.vue?vue&type=script&lang=js"
export * from "./horizontal-scroll-manager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__